import React, { useEffect, useState } from 'react'
import { useForm } from 'react-hook-form'
import { Col, Container, FormGroup, Label, Row, Form, Button, Spinner } from 'reactstrap'
import useAddComparable from './useAddComparable'
import useUpdateCompOrSub from './useUpdateCompOrSub'

const AddEditDataForm = ({isEditMode,objData,onClose,orderId,lastInd}) => {
    console.log("orderId",orderId)
    // dummy data for type
    const dummmyType = [
        {label:"Subject", value:"subject"},
        {label:"Comparable", value:"comparable"}
    ]

    // custom hook to add comp or subject
    const{isPending, isSuccess, isError, addCompOrSub} = useAddComparable();
    // custom hook to edit comp
    const{isUpdating, isUpdated, updateCompOrSub} = useUpdateCompOrSub();
    // state to manage the colums when its comparable
    const[isComparable, setIsComparable] = useState(false)
    // state to manage the columns when its subject
    const[isSubject, setIsSubject] = useState(false)

    const{register, handleSubmit,formState:{errors},reset,watch,setValue} = useForm({
        defaultValues:{
            type:"",
            salePrice:"",
            pricePerSqFt:"",
            saleDate:"",
            location:"",
            siteSize:"",
            siteView:"",
            designStyle:"",
            ageYrs:"",
            condition:"",
            totalRooms:"",
            beds:"",
            baths:"",
            grossLivingArea:"",
            basement:"",
            heatCool:"",
            garageCarport:"",
            porchPatioDeck:"",
            crsFileLink:"",
            taxRecordsLink:"",
            mapRef:"",
            owner:"",
            propAddr:"",
            proxToSubj:"",
            mlsListing:"",
            overallComparison:""

        },
        criteriaMode:"all",
        mode:"onChange"
    })

    //when editing, populate from the existing data
    useEffect(() => {
        if (isEditMode && objData) {
            console.log("data for editing");

            const formValues = {
                type: objData.comp_type,
                salePrice: objData.sale_price,
                pricePerSqFt: objData.price_per_gross_living_area,
                saleDate: objData.sale_date,
                location: objData.location,
                siteSize: objData.site_size,
                siteView: objData.site_view,
                designStyle: objData.design_style,
                ageYrs: objData.age_years,
                condition: objData.condition,
                totalRooms: objData.total_rooms,
                beds: objData.bedrooms,
                baths: objData.baths,
                grossLivingArea: objData.gross_living_area,
                basement: objData.basement,
                heatCool: objData.heat_cool,
                garageCarport: objData.garage_carport,
                porchPatioDeck: objData.porch_patio,
                crsFileLink: objData.crs_file_link,
                taxRecordsLink: objData.tax_records_link,
                mapRef: objData.map_ref || "",
                owner: objData.curr_owner || "",
                propAddr: objData.property_address || "",
                proxToSubj: objData.proximity || "",
                mlsListing: objData.mls_listing || "", 
                overallComparison: objData.overall_comparison || "",
            };

            reset(formValues);
        } else {
            reset();
        }
    }, [isEditMode, objData, reset]);

    // useEffect(()=>{
    //     console.log("order_id",orderId || '',
    //         "id",objData.id || '',
    //         "comp_id",objData.comp_id || ''
    //     )

    // },[])
    
    const onSubmit=(data)=>{
        
        if(isEditMode){
            console.log("edited_data",data)
            const payload = {
                data:[
                    {
                        order_id: orderId,
                        id: objData.id || null,             // subject ID
                        comp_id: objData.comp_id || null,   // comparable ID

                        // Subject & Comparable shared fields
                        location: data.location,
                        salePrice: data.salePrice,
                        saleDate: data.saleDate,
                        ageYrs: data.ageYrs,
                        grossLivingArea: data.grossLivingArea,
                        pricePerSqFt: data.pricePerSqFt,
                        siteSize: data.siteSize,
                        siteView: data.siteView,
                        designStyle: data.designStyle,
                        condition: data.condition,
                        totalRooms: data.totalRooms,
                        beds: data.beds,
                        baths: data.baths,
                        basement: data.basement,
                        heatCool: data.heatCool,
                        garageCarport: data.garageCarport,
                        porchPatioDeck: data.porchPatioDeck,
                        crsFileLink: data.crsFileLink,
                        taxRecordsLink: data.taxRecordsLink,
                        mapRef: data.mapRef,
                        // Comparable-specific fields
                        owner: data.owner,
                        propAddr: data.propAddr,
                        proxToSubj: data.proxToSubj,
                        mlsListing: data.mlsListing,
                        overallComparison: data.overallComparison
                    }
                ]
            }
            updateCompOrSub(payload,{
                onSuccess:()=>{
                    onClose();
                }
            })
        }else{
            console.log("added_data",data)
            const newData = {
                data:[
                    {
                        ...data,
                        sequence: lastInd + 1
                    }
                ],
                orderId: orderId
            }
            console.log("added_datanew",newData)
            addCompOrSub(newData,{
                onSuccess:()=>{
                    onClose();
                }
            })
        }
    }

    // getting the value of type
    const typeValue = watch("type")
    console.log(typeValue)
    useEffect(()=>{
        if (typeValue === 'comparable'){

            setIsComparable(true)
        }else{
            setIsComparable(false)
        }
        
        if(typeValue === 'subject'){
            setIsSubject(true)
        }else{
            setIsSubject(false)
        }
    },[typeValue])

    // for checkbox in overall compariosn
    const selected = watch("overallComparison")
    const handleCheck=(value)=>{
        setValue('overallComparison',selected===value?'':value)
    }
    
  return (
    <Container fluid>
        <Row>
          <Col>
              <Form onSubmit={handleSubmit(onSubmit)}>
                <Row>
                    {/* The "Type" dropdown is in a fixed-width column. It will not change size. */}
                    <Col md={3}>
                        <FormGroup>
                            <Label htmlFor='type' className='form-label'>Type</Label>
                                <select
                                    className='form-select border-primary-subtle'
                                    id='type'
                                    name='type'
                                    defaultValue=''
                                    {...register("type",{required: "Type is Required"})}
                                >
                                    <option value="" disabled>Select Type</option>
                                    {dummmyType.map((type,index)=>(
                                        <option key={index} value={type.value}>{type.label}</option>
                                    ))}
                                </select>
                            {errors.type && <span className="text-danger">{errors.type.message}</span>}
                        </FormGroup>
                    </Col>
                    
                    {/* This column acts as a container for the conditional fields. */}
                    <Col md={9}>
                        {isComparable && (
                            // A new <Row> is nested inside the container.
                            // Its columns will fill the container's space.
                            <Row>
                                <Col md={4}>
                                    <FormGroup>
                                        <Label htmlFor='owner' className='form-label'>Current Owner</Label>
                                            <input
                                                type='text'
                                                className='form-control border-primary-subtle'
                                                id='owner'
                                                name='owner'
                                                placeholder='Current Owner'
                                                {...register("owner",{required: "Current Owner is Required"})}
                                            />
                                        {errors.owner && <span className="text-danger">{errors.owner.message}</span>}
                                    </FormGroup>   
                                </Col>
                                <Col md={4}>
                                    <FormGroup>
                                        <Label htmlFor='propAddr' className='form-label'>Address</Label>
                                            <input
                                                type='text'
                                                className='form-control border-primary-subtle'
                                                id='propAddr'
                                                name='propAddr'
                                                placeholder='Address'
                                                {...register("propAddr",{required: "Address is Required"})}
                                            />
                                        {errors.propAddr && <span className="text-danger">{errors.propAddr.message}</span>}
                                    </FormGroup>  
                                </Col>
                                <Col md={4}>
                                    <FormGroup>
                                        <Label htmlFor='proxToSubj' className='form-label'>Proximity</Label>
                                            <input
                                                type='text'
                                                className='form-control border-primary-subtle'
                                                id='proxToSubj'
                                                name='proxToSubj'
                                                placeholder='Proximity'
                                                {...register("proxToSubj",{required: "Proximity is Required"})}
                                            />
                                        {errors.proxToSubj && <span className="text-danger">{errors.proxToSubj.message}</span>}
                                    </FormGroup>   
                                </Col>
                            </Row>
                        )}
                    </Col>
                </Row>
                
                <Row>
                    <Col>
                        <FormGroup>
                            <Label htmlFor='location' className='form-label'>Location</Label>
                                <input
                                    type='text'
                                    className='form-control border-primary-subtle'
                                    id='location'
                                    name='location'
                                    placeholder='Location'
                                    {...register("location",{required: "Location is Required"})}
                                />
                            {errors.location && <span className="text-danger">{errors.location.message}</span>}
                        </FormGroup>
                    </Col>
                    
                    <Col>
                        <FormGroup>
                            <Label htmlFor='salePrice' className='form-label'>Sale Price</Label>
                                <input
                                    type='text'
                                    className='form-control border-primary-subtle'
                                    id='salePrice'
                                    name='salePrice'
                                    placeholder='Sale Price'
                                    {...register("salePrice")}
                                />
                            {errors.salePrice && <span className="text-danger">{errors.salePrice.message}</span>}
                        </FormGroup>
                    </Col>

                    <Col>
                        <FormGroup>
                            <Label htmlFor='saleDate' className='form-label'>Date of Sale</Label>
                                <input
                                    type='date'
                                    className='form-control border-primary-subtle'
                                    id='saleDate'
                                    name='saleDate'
                                    placeholder='Date of Sale Feet'
                                    {...register("saleDate")}
                                />
                            {errors.saleDate && <span className="text-danger">{errors.saleDate.message}</span>}
                        </FormGroup>     
                    </Col>
                    
                    <Col>
                        <FormGroup>
                            <Label htmlFor='ageYrs' className='form-label'>Age (Years)</Label>
                                <input
                                    type='text'
                                    className='form-control border-primary-subtle'
                                    id='ageYrs'
                                    name='ageYrs'
                                    placeholder='Age'
                                    {...register("ageYrs",{required: "Age is Required"})}
                                />
                            {errors.ageYrs && <span className="text-danger">{errors.ageYrs.message}</span>}
                        </FormGroup>   
                    </Col>
                </Row>

                <Row>
                    <Col>
                        <FormGroup>
                            <Label htmlFor='grossLivingArea' className='form-label'>Gross Living Area</Label>
                                <input
                                    type='text'
                                    className='form-control border-primary-subtle'
                                    id='grossLivingArea'
                                    name='grossLivingArea'
                                    placeholder='Gross Living Area'
                                    {...register("grossLivingArea",{required: "Gross Living Area is Required"})}
                                />
                            {errors.grossLivingArea && <span className="text-danger">{errors.grossLivingArea.message}</span>}
                        </FormGroup>     
                    </Col>

                    <Col>
                        <FormGroup>
                            <Label htmlFor='pricePerSqFt' className='form-label'>Price Per Square Feet</Label>
                                <input
                                    type='text'
                                    className='form-control border-primary-subtle'
                                    id='pricePerSqFt'
                                    name='pricePerSqFt'
                                    placeholder='Price Per Square Feet'
                                    {...register("pricePerSqFt",{required: "Price Per Square Feet is Required"})}
                                />
                            {errors.pricePerSqFt && <span className="text-danger">{errors.pricePerSqFt.message}</span>}
                        </FormGroup>      
                    </Col>

                    <Col>
                        <FormGroup>
                            <Label htmlFor='siteSize' className='form-label'>Site Size</Label>
                                <input
                                    type='text'
                                    className='form-control border-primary-subtle'
                                    id='siteSize'
                                    name='siteSize'
                                    placeholder='Site Size'
                                    {...register("siteSize",{required: "Site Size is Required"})}
                                />
                            {errors.siteSize && <span className="text-danger">{errors.siteSize.message}</span>}
                        </FormGroup>
                    </Col>
                                    
                    <Col>
                        <FormGroup>
                            <Label htmlFor='siteView' className='form-label'>Site View</Label>
                                <input
                                    type='text'
                                    className='form-control border-primary-subtle'
                                    id='siteView'
                                    name='siteView'
                                    placeholder='Site View'
                                    {...register("siteView",{required: "Site View is Required"})}
                                />
                            {errors.siteView && <span className="text-danger">{errors.siteView.message}</span>}
                        </FormGroup>
                    </Col>
                </Row>
                
                <Row>
                    <Col>
                        <FormGroup>
                            <Label htmlFor='designStyle' className='form-label'>Design</Label>
                                <input
                                    type='text'
                                    className='form-control border-primary-subtle'
                                    id='designStyle'
                                    name='designStyle'
                                    placeholder='Design'
                                    {...register("designStyle",{required: "Design is Required"})}
                                />
                            {errors.designStyle && <span className="text-danger">{errors.designStyle.message}</span>}
                        </FormGroup>
                    </Col>
                    <Col>
                        <FormGroup>
                            <Label htmlFor='condition' className='form-label'>Condition</Label>
                                <input
                                    type='text'
                                    className='form-control border-primary-subtle'
                                    id='condition'
                                    name='condition'
                                    placeholder='Condition'
                                    {...register("condition",{required: "Condition is Required"})}
                                />
                            {errors.condition && <span className="text-danger">{errors.condition.message}</span>}
                        </FormGroup>  
                    </Col>
                    <Col>
                        <FormGroup>
                            <Label htmlFor='totalRooms' className='form-label'>Total Rooms</Label>
                                <input
                                    type='text'
                                    className='form-control border-primary-subtle'
                                    id='totalRooms'
                                    name='totalRooms'
                                    placeholder='Total Rooms'
                                    {...register("totalRooms",{required: "Total Rooms is Required"})}
                                />
                            {errors.totalRooms && <span className="text-danger">{errors.totalRooms.message}</span>}
                        </FormGroup>  
                    </Col>
                    <Col>
                        <FormGroup>
                            <Label htmlFor='beds' className='form-label'>Bed Rooms</Label>
                                <input
                                    type='text'
                                    className='form-control border-primary-subtle'
                                    id='beds'
                                    name='beds'
                                    placeholder='Bed Rooms'
                                    {...register("beds",{required: "Bed Rooms is Required"})}
                                />
                            {errors.beds && <span className="text-danger">{errors.beds.message}</span>}
                        </FormGroup> 
                    </Col>
                    
                </Row>
                
                <Row>
                    <Col>
                        <FormGroup>
                            <Label htmlFor='baths' className='form-label'>Baths</Label>
                                <input
                                    type='text'
                                    className='form-control border-primary-subtle'
                                    id='baths'
                                    name='baths'
                                    placeholder='Baths'
                                    {...register("baths",{required: "Baths is Required"})}
                                />
                            {errors.baths && <span className="text-danger">{errors.baths.message}</span>}
                        </FormGroup> 
                    </Col>
                    <Col>
                        <FormGroup>
                            <Label htmlFor='basement' className='form-label'>Basement</Label>
                                <input
                                    type='text'
                                    className='form-control border-primary-subtle'
                                    id='basement'
                                    name='basement'
                                    placeholder='Basement'
                                    {...register("basement",{required: "Basement is Required"})}
                                />
                            {errors.basement && <span className="text-danger">{errors.basement.message}</span>}
                        </FormGroup>     
                    </Col>
                    <Col>
                        <FormGroup>
                            <Label htmlFor='heatCool' className='form-label'>Heating/Cooling</Label>
                                <input
                                    type='text'
                                    className='form-control border-primary-subtle'
                                    id='heatCool'
                                    name='heatCool'
                                    placeholder='Heating/Cooling'
                                    {...register("heatCool",{required: "Heating/Cooling is Required"})}
                                />
                            {errors.heatCool && <span className="text-danger">{errors.heatCool.message}</span>}
                        </FormGroup> 
                    </Col>

                    <Col>
                        <FormGroup>
                            <Label htmlFor='garageCarport' className='form-label'>Garage/Carport</Label>
                                <input
                                    type='text'
                                    className='form-control border-primary-subtle'
                                    id='garageCarport'
                                    name='garageCarport'
                                    placeholder='Garage/Carport'
                                    {...register("garageCarport",{required: "Garage/Carport is Required"})}
                                />
                            {errors.garageCarport && <span className="text-danger">{errors.garageCarport.message}</span>}
                        </FormGroup>      
                    </Col>

                </Row>
                
                <Row>
                    <Col md={3}>
                        <FormGroup>
                            <Label htmlFor='porchPatioDeck' className='form-label'>Porch/Patio/Deck</Label>
                                <input
                                    type='text'
                                    className='form-control border-primary-subtle'
                                    id='porchPatioDeck'
                                    name='porchPatioDeck'
                                    placeholder='Porch/Patio/Deck'
                                    {...register("porchPatioDeck",{required: "Porch/Patio/Deck is Required"})}
                                />
                            {errors.porchPatioDeck && <span className="text-danger">{errors.porchPatioDeck.message}</span>}
                        </FormGroup>        
                    </Col>

                    {isComparable && <Col>
                        <FormGroup>
                            <Label htmlFor='mlsListing' className='form-label'>MLS Listing Number</Label>
                                <input
                                    type='text'
                                    className='form-control border-primary-subtle'
                                    id='mlsListing'
                                    name='mlsListing'
                                    placeholder='MLS Listing Number'
                                    {...register("mlsListing",{required: "MLS Listing is Required"})}
                                />
                            {errors.mlsListing && <span className="text-danger">{errors.mlsListing.message}</span>}
                        </FormGroup>  
                    </Col>}
                    <Col md={3}>
                        <FormGroup>
                            <Label htmlFor='crsFileLink' className='form-label'>CRS File Link</Label>
                                <input
                                    type='text'
                                    className='form-control border-primary-subtle'
                                    id='crsFileLink'
                                    name='crsFileLink'
                                    placeholder='CRS File Link'
                                    {...register("crsFileLink")}
                                />
                            {errors.crsFileLink && <span className="text-danger">{errors.crsFileLink.message}</span>}
                        </FormGroup>
                    </Col>
                    <Col md={3}>
                        <FormGroup>
                            <Label htmlFor='taxRecordsLink' className='form-label'>Tax Records Link</Label>
                                <input
                                    type='text'
                                    className='form-control border-primary-subtle'
                                    id='taxRecordsLink'
                                    name='taxRecordsLink'
                                    placeholder='Tax Records Link'
                                    {...register("taxRecordsLink")}
                                />
                            {errors.taxRecordsLink && <span className="text-danger">{errors.taxRecordsLink.message}</span>}
                        </FormGroup>
                    </Col>
                    {!isComparable && (<Col md={3}>
                        <FormGroup>
                            <Label htmlFor='mapRef' className='form-label'>Map Ref</Label>
                                <input
                                    type='text'
                                    className='form-control border-primary-subtle'
                                    id='mapRef'
                                    name='mapRef'
                                    placeholder='Map Ref'
                                    {...register("mapRef")}
                                />
                            {errors.mapRef && <span className="text-danger">{errors.mapRef.message}</span>}
                        </FormGroup>
                    </Col>)}
                </Row>
                <Row>
                    {isComparable && (<Col>
                        <FormGroup>
                        <Label htmlFor='overallComparison' className='form-label d-block'>Overall Comparison</Label>
                        <div className='d-flex gap-3'>
                            {["superior", "similar", "inferior"].map((option) => (
                            <div className='form-check' key={option}>
                                <input
                                type='radio'
                                className='form-check-input border border-primary'
                                id={`overallComparison-${option}`}
                                value={option}
                                {...register("overallComparison")}
                                checked={selected==option}
                                onChange={()=>handleCheck(option)}
                                />
                                <Label className='form-check-label' htmlFor={`overallComparison-${option}`}>
                                {option.charAt(0).toUpperCase() + option.slice(1)}
                                </Label>
                            </div>
                            ))}
                        </div>
                        {errors.overallComparison && (
                            <span className="text-danger">{errors.overallComparison.message}</span>
                        )}
                        </FormGroup>
                    </Col>)}
                </Row>
                <Row>
                    <div style={{display:"flex", flexDirection:"row", alignItems:"center",justifyContent:"center"}}>
                        <Button type='submit' style={{ backgroundColor: "#00ADF0", color: "white", minWidth: "150px", fontWeight: "bolder" }} disabled={isPending || isUpdating}>{(isPending || isUpdating) ?(<Spinner size='sm'/>) : (isEditMode ? 'Update' : 'Add')}</Button>
                    </div>
                </Row>
              </Form>
          </Col>
        </Row>
    </Container>
  )
}

export default AddEditDataForm